export const GUEST_VIEWS = ["gallery", "find", "mine", "profile"];

export function getGuestViewFromUrl(location = globalThis.location) {
  if (!location) return "gallery";
  const url = new URL(
    location.href || `${location.pathname || "/"}${location.search || ""}`,
    "http://localhost"
  );
  const view = url.searchParams.get("view");
  return GUEST_VIEWS.includes(view) ? view : "gallery";
}

export function navigateGuestView(
  view,
  history = globalThis.history,
  location = globalThis.location
) {
  if (!GUEST_VIEWS.includes(view) || !history || !location) return false;
  const url = new URL(location.href, "http://localhost");
  url.searchParams.set("view", view);
  history.pushState(
    { ...(history.state || {}), view },
    "",
    `${url.pathname}${url.search}${url.hash}`
  );
  return true;
}
